// extracted by mini-css-extract-plugin
export default {"container":"X_IRfx_ykRYS87v7BGp2","title":"aNDK1qMJsHGmekBSQL3L","description":"FBAygZqVHTBD9F8qUcQy"};